"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assetUploadVCard = exports.assetUploadSuccess = exports.assetUploadResource = exports.assetUploadResetVCard = exports.assetUploadResetProfile = exports.assetUploadResetImpact = exports.assetUploadReset = exports.assetUploadRemoveVCard = exports.assetUploadRemoveProfile = exports.assetUploadProfile = exports.assetUploadPrintbridgeDefault = exports.assetUploadImpactDefault = exports.assetUploadImpact = exports.assetUploadImageFund = exports.assetUploadFundDefault = exports.assetUploadError = exports.assetUploadCroppedImage = void 0;
var _assetUpload = require("./assetUpload.constant");
// @flow

// common success
var assetUploadSuccess = function assetUploadSuccess(actionType, data) {
  return {
    type: _assetUpload.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.assetUploadSuccess = assetUploadSuccess;
var assetUploadError = function assetUploadError(actionType, error) {
  return {
    type: _assetUpload.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * fund default
 * @param payload
 * @returns api response
 * @description this function used to upload data.
 */
exports.assetUploadError = assetUploadError;
var assetUploadFundDefault = function assetUploadFundDefault(data) {
  return {
    type: _assetUpload.actionTypes.FUND_DEFAULT,
    payload: data
  };
};

/**
 * impact default
 * @param payload
 * @returns api response
 * @description this function used to upload data.
 */
exports.assetUploadFundDefault = assetUploadFundDefault;
var assetUploadImpactDefault = function assetUploadImpactDefault(data) {
  return {
    type: _assetUpload.actionTypes.IMPACT_DEFAULT,
    payload: data
  };
};

/**
 * print bridge default
 * @param payload
 * @returns api response
 * @description this function used to upload data.
 */
exports.assetUploadImpactDefault = assetUploadImpactDefault;
var assetUploadPrintbridgeDefault = function assetUploadPrintbridgeDefault(data) {
  return {
    type: _assetUpload.actionTypes.PRINTBRIGE_DEFAULT,
    payload: data
  };
};

/**
 * upload
 * @param payload
 * @returns api response
 * @description this function used to upload data.
 */
exports.assetUploadPrintbridgeDefault = assetUploadPrintbridgeDefault;
var assetUploadProfile = function assetUploadProfile(data) {
  return {
    type: _assetUpload.actionTypes.UPLOAD_PROFILE,
    payload: data
  };
};

/**
 * upload
 * @param payload
 * @returns api response
 * @description this function used to upload data.
 */
exports.assetUploadProfile = assetUploadProfile;
var assetUploadCroppedImage = function assetUploadCroppedImage(data) {
  return {
    type: _assetUpload.actionTypes.UPLOAD_CROPPED_IMAGE,
    payload: data
  };
};

/**
 * remove
 * @param payload
 * @returns api response
 * @description this function used to remove data.
 */
exports.assetUploadCroppedImage = assetUploadCroppedImage;
var assetUploadRemoveProfile = function assetUploadRemoveProfile(data) {
  return {
    type: _assetUpload.actionTypes.REMOVE_PROFILE,
    payload: data
  };
};

/**
 * reset
 * @param payload
 * @returns api response
 * @description this function used to reset data.
 */
exports.assetUploadRemoveProfile = assetUploadRemoveProfile;
var assetUploadResetProfile = function assetUploadResetProfile() {
  return {
    type: _assetUpload.actionTypes.RESET_PROFILE
  };
};

/**
 * upload
 * @param payload
 * @returns api response
 * @description this function used to upload data.
 */
exports.assetUploadResetProfile = assetUploadResetProfile;
var assetUploadVCard = function assetUploadVCard(data) {
  return {
    type: _assetUpload.actionTypes.UPLOAD_VCARD,
    payload: data
  };
};

/**
 * remove
 * @param payload
 * @returns api response
 * @description this function used to remove data.
 */
exports.assetUploadVCard = assetUploadVCard;
var assetUploadRemoveVCard = function assetUploadRemoveVCard(data) {
  return {
    type: _assetUpload.actionTypes.REMOVE_VCARD,
    payload: data
  };
};

/**
 * remove
 * @param payload
 * @returns api response
 * @description this function used to remove data.
 */
exports.assetUploadRemoveVCard = assetUploadRemoveVCard;
var assetUploadResource = function assetUploadResource(param, data) {
  return {
    type: _assetUpload.actionTypes.UPLOAD_RESOURCE,
    payload: {
      param: param,
      data: data
    }
  };
};

/**
 * remove
 * @param payload
 * @returns api response
 * @description this function used to remove data.
 */
exports.assetUploadResource = assetUploadResource;
var assetUploadImageFund = function assetUploadImageFund(data) {
  return {
    type: _assetUpload.actionTypes.UPLOAD_IMAGE_FUND,
    payload: data
  };
};

/**
 * upload
 * @param payload
 * @returns api response
 * @description this function used to upload data.
 */
exports.assetUploadImageFund = assetUploadImageFund;
var assetUploadImpact = function assetUploadImpact(data) {
  return {
    type: _assetUpload.actionTypes.UPLOAD_IMPACT,
    payload: data
  };
};

/**
 * reset
 * @param payload
 * @returns api response
 * @description this function used to remove data.
 */
exports.assetUploadImpact = assetUploadImpact;
var assetUploadResetImpact = function assetUploadResetImpact() {
  return {
    type: _assetUpload.actionTypes.RESET_UPLOAD_IMPACT
  };
};

/**
 * reset
 * @param payload
 * @returns api response
 * @description this function used to reset data.
 */
exports.assetUploadResetImpact = assetUploadResetImpact;
var assetUploadResetVCard = function assetUploadResetVCard() {
  return {
    type: _assetUpload.actionTypes.RESET_VCARD
  };
};

/**
 * reset
 * @param payload
 * @returns api response
 * @description this function used to reset data.
 */
exports.assetUploadResetVCard = assetUploadResetVCard;
var assetUploadReset = function assetUploadReset() {
  return {
    type: _assetUpload.actionTypes.RESET
  };
};
exports.assetUploadReset = assetUploadReset;